import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { getTotalTypesLabel } from "helpers/metrics/legacy-metrics";
import { formatMessage } from "lib/globalize-util";
import { ISortOrder } from "../../../tool-panels";
import { PlanMetricRows } from "../pinned-row-constants";
import { getPlanRowType } from "../pinned-row-helpers";
import { createMarkup } from "lib/helpers";

interface IProps extends ICellRendererParams {
    displayPlanMetrics?: boolean;
    displayTotals?: boolean;
    onClick?: () => void;
}

class LabelCell implements ICellRendererComp {
    declare eGui: HTMLElement;
    declare planRowType: PlanMetricRows;

    private getLabel() {
        let planValue = "";
        if (this.planRowType === PlanMetricRows.Diff) {
            planValue = formatMessage("Diff");
        } else if (this.planRowType === PlanMetricRows.Plan) {
            planValue = formatMessage("Plan");
        } else if (this.planRowType === PlanMetricRows.Total) {
            planValue = formatMessage("Total");
        }

        return planValue;
    }

    private buildValueElement(params: IProps) {
        // create the cell
        if (!this.getGui()) {
            this.eGui = document.createElement("div");
            this.eGui.className = "planHeader";
            this.eGui.onclick = params.data.onClick;
        } else {
            this.getGui().innerHTML = "";
        }

        if (this.planRowType === PlanMetricRows.Plan && params.data?.totalType) {
            const planType = document.createElement("div");
            planType.className = "planTitle planType";
            planType.innerText = getTotalTypesLabel(params.data.totalType);
            this.eGui.appendChild(planType);
        }
        const metricType = document.createElement("div");
        metricType.className = `planTitle ${this.planRowType}MetricType`;
        metricType.innerHTML = createMarkup(`<span>${this.getLabel()}</span>`);
        this.eGui.appendChild(metricType);

        if (params.data.pinnedRowSorts?.length) {
            const pinnedRowSort = params.data.pinnedRowSorts[0];
            const arrSort = pinnedRowSort.id.split("-");
            if (arrSort[0] === params.data.totalType && arrSort[1] === params.data.planType) {
                const icon = document.createElement("span");
                icon.classList.add("ag-icon");
                icon.classList.add(`ag-icon-${pinnedRowSort.order === ISortOrder.Ascending ? "asc" : "desc"}`);
                this.eGui.appendChild(icon);
            }
        }
    }

    refresh(params: IProps): boolean {
        // Static cell. Do nothing on refresh.
        this.buildValueElement(params);
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }
    init(params: IProps) {
        this.planRowType = getPlanRowType(params.node.rowIndex);
        this.buildValueElement(params);
    }
}

export { LabelCell };
